import { EntidadeBase } from 'hay-core-react';
class HomologacaoRouterboardModel extends EntidadeBase {
    constructor() { super('homologacaorouterboard'); }
}

const instance = new HomologacaoRouterboardModel();
export default instance;
